var _rect, _path, _g, _g2, _g3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMarkingFinInstruments(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.7892 22.4713H15.7888C12.8405 22.4713 10.4416 20.0734 10.4416 17.1274C10.4416 14.1814 12.8405 11.7834 15.7888 11.7834C18.7371 11.7834 21.1359 14.1815 21.1359 17.1274V17.1279C21.1368 18.0031 20.921 18.8649 20.5079 19.6366L20.5078 19.6368C19.9368 20.7045 19.0137 21.5571 17.8953 22.0384L18.0929 22.4977L17.8952 22.0384C17.2301 22.3246 16.5134 22.472 15.7892 22.4713ZM13.5011 25.1137H16.2968C16.0612 25.9449 15.935 26.8214 15.935 27.7262V38.7002C15.935 38.7003 15.935 38.7003 15.935 38.7004C15.9349 38.9691 15.9596 39.2367 16.0084 39.5H10.9007C9.02568 39.5 7.5 37.9747 7.5 36.1015V31.1113C7.5 27.8049 10.1923 25.1137 13.5011 25.1137ZM19.5355 27.7262C19.5355 24.4198 22.2277 21.7286 25.5366 21.7286H33.4989C36.8077 21.7286 39.5 24.4198 39.5 27.7262V38.7004C39.5 39.1417 39.142 39.4999 38.6998 39.4999H20.3357C19.8935 39.4999 19.5355 39.1416 19.5355 38.7004V27.7262ZM22.1993 11.8142C22.1993 7.7818 25.4825 4.5 29.5177 4.5C33.5529 4.5 36.8361 7.78189 36.8361 11.8142C36.8361 14.5482 35.3268 16.9382 33.0936 18.1937C32.0356 18.7885 30.8163 19.1284 29.5177 19.1284C28.2192 19.1284 26.9999 18.7885 25.9419 18.1937C23.7088 16.9382 22.1993 14.5483 22.1993 11.8142Z",
    fill: "url(#paint0_linear_24786_52085)",
    stroke: "url(#paint1_radial_24786_52085)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_24786_52085)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28 29C28 26.7909 29.7909 25 32 25H50C52.2091 25 54 26.7909 54 29V54C54 54.5523 53.5523 55 53 55H29C28.4477 55 28 54.5523 28 54V29Z",
    fill: "url(#paint2_linear_24786_52085)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28 29C28 26.7909 29.7909 25 32 25H50C52.2091 25 54 26.7909 54 29V54C54 54.5523 53.5523 55 53 55H29C28.4477 55 28 54.5523 28 54V29Z",
    fill: "url(#paint3_radial_24786_52085)",
    fillOpacity: 0.5
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_24786_52085)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.5 32.5C31.5 31.6716 32.1716 31 33 31H48C48.8284 31 49.5 31.6716 49.5 32.5C49.5 33.3284 48.8284 34 48 34H33C32.1716 34 31.5 33.3284 31.5 32.5Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_24786_52085)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.5 38.5C31.5 37.6716 32.1716 37 33 37H48C48.8284 37 49.5 37.6716 49.5 38.5C49.5 39.3284 48.8284 40 48 40H33C32.1716 40 31.5 39.3284 31.5 38.5Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_24786_52085",
    x: 20,
    y: 17,
    width: 42,
    height: 46,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_24786_52085"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_24786_52085",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_24786_52085",
    x: 31.5,
    y: 31,
    width: 19,
    height: 4,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_24786_52085"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_24786_52085",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_24786_52085",
    x: 31.5,
    y: 37,
    width: 19,
    height: 4,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_24786_52085"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_24786_52085",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_24786_52085",
    x1: 7,
    y1: 4,
    x2: 25.9172,
    y2: 38.6815,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF0400"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_24786_52085",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-1.88461 -13.3077) rotate(57.8266) scale(41.7131 40.2979)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_24786_52085",
    x1: 28,
    y1: 25,
    x2: 44.232,
    y2: 53.1354,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F09C9C",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A6D7F0",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_24786_52085",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(28 25) scale(26 30)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarkingFinInstruments);
export default __webpack_public_path__ + "static/media/markingFinInstruments.1633dbc5608fe2ac3efb9300f12c4d4f.svg";
export { ForwardRef as ReactComponent };